// Parser markdown mínimo para PDF. Soporta: párrafos (línea en blanco),
// listas "- "/"+ "/"* ", subtítulos "## ", y negritas **x** inline.
// NO soporta tablas/imágenes inline (esas son secciones del motor).

export function parseInlineSpans(line) {
  const text = String(line ?? '');
  if (!text) return [];
  const parts = text.split(/(\*\*[^*]+\*\*)/g).filter((p) => p !== '');
  return parts.map((part) =>
    part.startsWith('**') && part.endsWith('**')
      ? { text: part.slice(2, -2), bold: true }
      : { text: part, bold: false }
  );
}

export function parseMarkdownBlocks(markdown) {
  const src = typeof markdown === 'string' ? markdown : '';
  if (!src.trim()) return [];
  const blocks = [];
  for (const rawLine of src.split('\n')) {
    const line = rawLine.trim();
    if (line === '') continue;
    if (line.startsWith('## ')) {
      blocks.push({ type: 'h2', spans: parseInlineSpans(line.slice(3).trim()) });
    } else if (/^[-+*]\s/.test(line)) {
      blocks.push({ type: 'li', spans: parseInlineSpans(line.replace(/^[-+*]\s/, '')) });
    } else {
      blocks.push({ type: 'p', spans: parseInlineSpans(line) });
    }
  }
  return blocks;
}
